import { render, staticRenderFns } from "./OrderSims.vue?vue&type=template&id=35c240a2&"
import script from "./OrderSims.vue?vue&type=script&lang=js&"
export * from "./OrderSims.vue?vue&type=script&lang=js&"
import style0 from "./OrderSims.vue?vue&type=style&index=0&id=35c240a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports